﻿function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
}

function setCookie(name, value, days) {
  const date = new Date();
  date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
  document.cookie = `${name}=${value}; expires=${date.toUTCString()}; path=/`;
}

function clearCookie(name) {
  document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
}

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function safeParseJSON(value, fallback = null) {
  if (!value) return fallback;

  try {
    return JSON.parse(value);
  } catch (error) {
    console.warn('[FacetFiltersForm] Invalid JSON cookie value', error);
    return fallback;
  }
}

function getStoredColors() {
  const storedColors = safeParseJSON(getCookie('selected_color'), []);
  return Array.isArray(storedColors) ? storedColors : [];
}

function escapeSelector(value) {
  if (typeof CSS !== 'undefined' && typeof CSS.escape === 'function') {
    return CSS.escape(value);
  }
  return String(value).replace(/["\\]/g, '\\$&');
}

class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();

    this.debouncedOnSubmit = debounce((event) => {
      try {
        this.onSubmitHandler(event);
      } catch (error) {
        console.error('[FacetFiltersForm] Submit failed', error);
        FacetFiltersForm.resetUiState();
      }
    }, 500);

    const facetForm = this.querySelector('form');
    if (!facetForm) {
      console.warn('[FacetFiltersForm] Missing form element');
      return;
    }

    this._onFormChange = this.debouncedOnSubmit.bind(this);
    facetForm.addEventListener('input', this._onFormChange);
    facetForm.addEventListener('change', this._onFormChange);
    this.addEventListener('input', this._onFormChange);
    this.addEventListener('change', this._onFormChange);
  }

  disconnectedCallback() {
    const facetForm = this.querySelector('form');
    if (facetForm && this._onFormChange) {
      facetForm.removeEventListener('input', this._onFormChange);
      facetForm.removeEventListener('change', this._onFormChange);
    }
    if (this._onFormChange) {
      this.removeEventListener('input', this._onFormChange);
      this.removeEventListener('change', this._onFormChange);
    }
  }

  connectedCallback() {
    FacetFiltersForm.init();
  }

  static initFilterToggle() {
    const toggleButton = document.getElementById('toggleButton');
    if (!toggleButton || toggleButton._filterToggleBound) return;

    toggleButton._filterToggleBound = true;
    toggleButton.addEventListener('click', function () {
      this.classList.toggle('open');
      document.querySelectorAll('.js-filter-wrapper.should-hide').forEach((el) => {
        if (el.classList.contains('hide')) {
          el.classList.remove('hide');
          void el.offsetWidth;
          el.classList.add('show');
        } else {
          el.classList.remove('show');
          setTimeout(() => {
            el.classList.add('hide');
          }, 300);
        }
      });
    });
  }

  static initMobileFilterBackdrop() {
    const backdrop = document.querySelector('[data-mobile-filter-backdrop]');
    if (!backdrop || backdrop._mobileBackdropBound) return;

    backdrop._mobileBackdropBound = true;
    backdrop.addEventListener('click', FacetFiltersForm.closeFilterDrawer);
  }

  static setMobileFilterDrawerOpen(isOpen) {
    const drawer = document.querySelector('.mobile-filter');
    const backdrop = document.querySelector('[data-mobile-filter-backdrop]');

    drawer?.classList.toggle('open', isOpen);

    if (isOpen) {
      backdrop?.removeAttribute('hidden');
      document.body.classList.add('mobile-filter-open');
    } else {
      backdrop?.setAttribute('hidden', '');
      document.body.classList.remove('mobile-filter-open');
    }
  }

  static updateArmWidthLinks() {
    const search = window.location.search;
    document.querySelectorAll('.facet-arm-width__option[data-paired-path]').forEach((link) => {
      link.href = `${link.dataset.pairedPath}${search}`;
    });
  }

  static init() {
    try {
      document.querySelectorAll('.active-filter-item').forEach((elm) => {
        FacetFiltersForm.handleButtonClick(elm);
      });

      document.querySelectorAll('.filter-sort_by .filter-item').forEach((elm) => {
        if (elm._filterItemBound) return;
        FacetFiltersForm.handleFilterItem(elm);
        elm._filterItemBound = true;
      });

      const mobileOpener = document.querySelector('.mobile-filter-opener');
      if (mobileOpener && !mobileOpener._mobileFilterBound) {
        mobileOpener.addEventListener('click', FacetFiltersForm.handleMobileFilterClick);
        mobileOpener._mobileFilterBound = true;
      }

      const mobileClose = document.querySelector('.mobile-filter-header button');
      if (mobileClose && !mobileClose._mobileFilterCloseBound) {
        mobileClose.addEventListener('click', FacetFiltersForm.closeFilterDrawer);
        mobileClose._mobileFilterCloseBound = true;
      }

      FacetFiltersForm.initMobileFilterBackdrop();
      FacetFiltersForm.initFilterToggle();
      FacetFiltersForm.applyStoredColorOrder();
      FacetFiltersForm.updateArmWidthLinks();
    } catch (error) {
      console.error('[FacetFiltersForm] init failed', error);
      FacetFiltersForm.resetUiState();
    }
  }

  static getFacetForm() {
    return document.getElementById('FacetFiltersForm');
  }

  static applyStoredColorOrder() {
    const storedColors = getStoredColors();
    if (storedColors.length <= 1) return;

    const firstValue = FacetFiltersForm.processString(storedColors[0]).replace(' ', '-').toLowerCase();
    const swatchesEl = document.querySelectorAll('.color__swatch');

    swatchesEl.forEach((el) => {
      el.querySelectorAll('li').forEach((swatch) => {
        const name = swatch.dataset.optionName;
        if (name && name.includes(firstValue)) {
          swatch.classList.add('open');
        }
      });
    });

    FacetFiltersForm.setColorOrder(swatchesEl);
  }

  static handleMobileFilterClick() {
    const drawer = document.querySelector('.mobile-filter');
    FacetFiltersForm.setMobileFilterDrawerOpen(!drawer?.classList.contains('open'));
  }

  static openFilterDrawer() {
    FacetFiltersForm.setMobileFilterDrawerOpen(true);
  }

  static closeAllFilterMenus() {
    document.querySelectorAll('.js-filter-wrapper.open').forEach((wrapper) => {
      wrapper.classList.remove('open');
    });
  }

  static closeFilterDrawer() {
    FacetFiltersForm.setMobileFilterDrawerOpen(false);
  }

  static resetUiState() {
    FacetFiltersForm.removeLoader();
    FacetFiltersForm.isRendering = false;
    document.querySelector('facet-filters-form')?.classList.remove('is-loading');
  }

  static handleButtonClick(elm) {
    FacetFiltersForm.removeButtonClickListener(elm);

    const handleClick = (event) => {
      try {
        const wrapper = event.currentTarget?.closest('.js-filter-wrapper');
        if (!wrapper) return;

        if (!wrapper.classList.contains('open')) {
          FacetFiltersForm.openFilterItem(event);
        } else {
          wrapper.classList.remove('open');
        }
        FacetFiltersForm.closeFilterItem(event);
      } catch (error) {
        console.error('[FacetFiltersForm] Filter toggle failed', error);
      }
    };

    elm._handleClick = handleClick;
    elm.addEventListener('click', handleClick);
  }

  static removeButtonClickListener(elm) {
    if (elm._handleClick) {
      elm.removeEventListener('click', elm._handleClick);
      delete elm._handleClick;
    }
  }

  static handleFilterItem(elm) {
    elm.addEventListener('click', FacetFiltersForm.changeFilterValue);
  }

  static openFilterItem(event) {
    event.currentTarget?.closest('.js-filter-wrapper')?.classList.add('open');
  }

  static closeFilterItem(event) {
    const currentWrapper = event.currentTarget?.closest('.js-filter-wrapper');
    document.querySelectorAll('.js-filter-wrapper').forEach((elm) => {
      if (elm !== currentWrapper) {
        elm.classList.remove('open');
      }
    });
  }

  static changeFilterValue(event) {
    const wrapper = event.currentTarget?.closest('.js-filter-wrapper');
    const form =
      event.currentTarget?.closest('form') ||
      event.currentTarget?.form ||
      FacetFiltersForm.getFacetForm();
    const select = wrapper?.querySelector('select');

    if (!wrapper || !form || !select) return;

    select.value = event.currentTarget.dataset.value;
    FacetFiltersForm.closeAllFilterMenus();
    form.dispatchEvent(new Event('input', { bubbles: true }));
  }

  static setListeners() {
    window.addEventListener('popstate', (event) => {
      try {
        const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
        if (searchParams === FacetFiltersForm.searchParamsPrev) return;
        FacetFiltersForm.renderPage(searchParams, null, false);
      } catch (error) {
        console.error('[FacetFiltersForm] popstate failed', error);
        FacetFiltersForm.resetUiState();
      }
    });

    window.addEventListener('pageshow', () => {
      FacetFiltersForm.resetUiState();
    });
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams ? `?${searchParams}` : ''}`);
  }

  static getSections() {
    const collectionProducts = document.getElementById('collection-products');
    if (!collectionProducts?.dataset?.sectionId) return [];

    return [{ section: collectionProducts.dataset.sectionId }];
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();

    const form =
      event.target.form ||
      event.target.closest('form') ||
      FacetFiltersForm.getFacetForm();
    if (!form) return;

    const inputEl = event.target.tagName === 'INPUT' ? event.target : null;

    if (inputEl) {
      FacetFiltersForm.closeAllFilterMenus();

      if (inputEl.closest('.mobile-filter')) {
        FacetFiltersForm.closeFilterDrawer();
      }

      try {
        const deviceId = inputEl.dataset.deviceId;
        if (deviceId) {
          const secondInput = form.querySelector(`#${escapeSelector(deviceId)}`);
          if (secondInput) {
            secondInput.checked = inputEl.checked;
          }
        }

        if (inputEl.name && inputEl.name.includes('color')) {
          const value = inputEl.value;
          const isSelected = inputEl.checked;
          const storedColors = getStoredColors();

          if (!storedColors.length) {
            if (isSelected) {
              setCookie('selected_color', JSON.stringify([inputEl.value]), 30);
            }
          } else if (!isSelected) {
            setCookie('selected_color', JSON.stringify(storedColors.filter((v) => v !== value)));
          } else if (storedColors.includes(value)) {
            setCookie(
              'selected_color',
              JSON.stringify([inputEl.value, ...storedColors.filter((v) => v !== value)])
            );
          } else {
            setCookie('selected_color', JSON.stringify([inputEl.value, ...storedColors]));
          }
        }
      } catch (error) {
        console.warn('[FacetFiltersForm] Color cookie sync failed', error);
      }
    }

    const searchParams = this.createSearchParams(form);
    this.onSubmitForm(searchParams, event);
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    const params = new URLSearchParams();
    const uniqueParams = new Map();

    for (const [key, value] of formData.entries()) {
      const paramKey = `${key}=${value}`;
      if (!uniqueParams.has(paramKey)) {
        uniqueParams.set(paramKey, value);
        params.append(key, value);
      }
    }

    return params.toString();
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    try {
      document.querySelectorAll('.active-filter-item').forEach(FacetFiltersForm.removeButtonClickListener);

      const sections = FacetFiltersForm.getSections();
      if (!sections.length) {
        console.warn('[FacetFiltersForm] Missing #collection-products section id');
        FacetFiltersForm.resetUiState();
        return;
      }

      const previousParams = FacetFiltersForm.searchParamsPrev;
      FacetFiltersForm.searchParamsPrev = searchParams;
      FacetFiltersForm.pendingSearchParams = searchParams;
      FacetFiltersForm.isRendering = true;

      if (updateURLHash) {
        FacetFiltersForm.updateURLHash(searchParams);
        FacetFiltersForm.updateArmWidthLinks();
      }

      sections.forEach((section) => {
        const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
        const filterDataUrl = (element) => element.url === url;

        if (FacetFiltersForm.filterData.some(filterDataUrl)) {
          FacetFiltersForm.renderSectionFromCache(filterDataUrl, event, url, previousParams);
        } else {
          FacetFiltersForm.renderSectionFromFetch(url, event, previousParams);
        }
      });

    } catch (error) {
      console.error('[FacetFiltersForm] renderPage failed', error);
      FacetFiltersForm.resetUiState();
    }
  }

  static showLoader() {
    const loader = document.querySelector('.product-loop-loader');
    if (loader) {
      loader.removeAttribute('hidden');
      loader.classList.add('show');
    }
    document.querySelector('facet-filters-form')?.classList.add('is-loading');
  }

  static removeLoader() {
    const loader = document.querySelector('.product-loop-loader');
    if (loader) {
      loader.classList.remove('show');
      loader.setAttribute('hidden', '');
    }
    document.querySelector('facet-filters-form')?.classList.remove('is-loading');
  }

  static abortPendingFetch() {
    if (FacetFiltersForm.abortController) {
      FacetFiltersForm.abortController.abort();
      FacetFiltersForm.abortController = null;
    }
  }

  static trimFilterCache() {
    const maxEntries = 12;
    if (FacetFiltersForm.filterData.length > maxEntries) {
      FacetFiltersForm.filterData = FacetFiltersForm.filterData.slice(-maxEntries);
    }
  }

  static fallbackToFullPage(url) {
    try {
      const fallbackUrl = new URL(url, window.location.origin);
      fallbackUrl.searchParams.delete('section_id');
      window.location.assign(`${fallbackUrl.pathname}${fallbackUrl.search}`);
    } catch (error) {
      console.error('[FacetFiltersForm] Full-page fallback failed', error);
      FacetFiltersForm.resetUiState();
    }
  }

  static handleRenderFailure(url, previousParams, reason) {
    console.error('[FacetFiltersForm] Render failed', reason);
    FacetFiltersForm.searchParamsPrev = previousParams;
    FacetFiltersForm.resetUiState();

    if (FacetFiltersForm.shouldUseFullPageFallback()) {
      FacetFiltersForm.fallbackToFullPage(url);
    }
  }

  static shouldUseFullPageFallback() {
    FacetFiltersForm.failedRequestCount = (FacetFiltersForm.failedRequestCount || 0) + 1;
    return FacetFiltersForm.failedRequestCount >= 2;
  }

  static renderSectionFromFetch(url, event, previousParams) {
    FacetFiltersForm.abortPendingFetch();
    FacetFiltersForm.abortController = new AbortController();
    FacetFiltersForm.activeRequestId = (FacetFiltersForm.activeRequestId || 0) + 1;
    const requestId = FacetFiltersForm.activeRequestId;

    FacetFiltersForm.showLoader();

    const timeoutId = window.setTimeout(() => {
      FacetFiltersForm.abortController?.abort();
    }, 15000);

    fetch(url, { signal: FacetFiltersForm.abortController.signal })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`Section fetch failed (${response.status})`);
        }
        return response.text();
      })
      .then((html) => {
        if (requestId !== FacetFiltersForm.activeRequestId) return;
        if (!html || !html.includes('sofa-collection')) {
          throw new Error('Section response missing product grid');
        }

        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.trimFilterCache();
        FacetFiltersForm.failedRequestCount = 0;
        FacetFiltersForm.applySectionHtml(html, event);
      })
      .catch((error) => {
        if (requestId !== FacetFiltersForm.activeRequestId) return;

        if (error?.name === 'AbortError') {
          FacetFiltersForm.handleRenderFailure(url, previousParams, 'Request timed out or was cancelled');
          return;
        }

        FacetFiltersForm.handleRenderFailure(url, previousParams, error);
      })
      .finally(() => {
        window.clearTimeout(timeoutId);

        if (requestId === FacetFiltersForm.activeRequestId) {
          FacetFiltersForm.isRendering = false;
          FacetFiltersForm.removeLoader();
          FacetFiltersForm.abortController = null;
        }
      });
  }

  static renderSectionFromCache(filterDataUrl, event, url, previousParams) {
    try {
      const cached = FacetFiltersForm.filterData.find(filterDataUrl);

      if (!cached?.html) {
        FacetFiltersForm.renderSectionFromFetch(url, event, previousParams);
        return;
      }

      FacetFiltersForm.failedRequestCount = 0;
      FacetFiltersForm.applySectionHtml(cached.html, event);
    } catch (error) {
      FacetFiltersForm.handleRenderFailure(url, previousParams, error);
    }
  }

  static applySectionHtml(html, event) {
    try {
      FacetFiltersForm.renderFilters(html, event);
      FacetFiltersForm.renderProductGridContainer(html);
      FacetFiltersForm.renderHerder(html);
      FacetFiltersForm.renderPagination(html);
      window.dispatchEvent(
        new CustomEvent('filterFormSubmit', {
          detail: { searchParams: FacetFiltersForm.pendingSearchParams || '' },
        })
      );
    } catch (error) {
      throw error;
    } finally {
      FacetFiltersForm.isRendering = false;
      FacetFiltersForm.removeLoader();
    }
  }

  static processString(str) {
    if (!str) return '';
    const match = String(str).match(/^(\d+_)(.*)/);
    return match ? match[2] : str;
  }

  static renderProductGridContainer(html) {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const nextGrid = doc.getElementById('sofa-collection');
    const currentGrid = document.getElementById('sofa-collection');

    if (!nextGrid || !currentGrid) {
      console.warn('[FacetFiltersForm] Missing #sofa-collection in response or page');
      return;
    }

    const storedColors = getStoredColors();
    if (storedColors.length > 1) {
      const firstValue = FacetFiltersForm.processString(storedColors[0]).replace(' ', '-').toLowerCase();

      doc.querySelectorAll('.color__swatch li.open').forEach((swatch) => {
        swatch.classList.remove('open');
      });

      doc.querySelectorAll('.color__swatch').forEach((el) => {
        el.querySelectorAll('li').forEach((swatch) => {
          const name = swatch.dataset.optionName;
          if (name && name.includes(firstValue)) {
            swatch.classList.add('open');
          }
        });
      });
    }

    currentGrid.innerHTML = nextGrid.innerHTML;
    FacetFiltersForm.applyStoredColorOrder();
  }

  static setColorOrder(swatchesEl) {
    const storedColors = getStoredColors();
    if (storedColors.length <= 1) return;

    storedColors.forEach((optionName, i) => {
      const nameValue = FacetFiltersForm.processString(optionName).replace(' ', '-').toLowerCase();
      swatchesEl.forEach((el) => {
        el.querySelectorAll('li').forEach((swatch) => {
          const name = swatch.dataset.optionName;
          if (name && name.includes(nameValue)) {
            swatch.style.setProperty('--order', i + 1);
          }
        });
      });
    });
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    parsedHTML.querySelectorAll('.filter-item input[type="checkbox"]').forEach((input) => {
      const id = input.getAttribute('id');
      if (!id) return;

      const el = document.getElementById(id);
      if (!el) return;

      el.checked = input.checked;
      el.disabled = input.disabled;

      const label = el.closest('.facets__label');
      if (label) {
        label.classList.toggle('disabled', input.disabled);
        label.classList.toggle('active', input.checked);
      }
    });

    FacetFiltersForm.init();
    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.updateArmWidthLinks();
  }

  static renderActiveFacets(html) {
    const activeFacetsElement = html.querySelector('.active-facets');
    const currentActiveFacets = document.querySelector('.active-facets');

    if (!activeFacetsElement || !currentActiveFacets) return;

    currentActiveFacets.innerHTML = activeFacetsElement.innerHTML;
  }

  onActiveFilterClick(event) {
    event.preventDefault();

    try {
      const facetLink = event.target.closest('.active-facets__button');
      if (facetLink) {
        if (facetLink.hasAttribute('data-clear-all')) {
          clearCookie('selected_color');
        } else {
          const color = facetLink.dataset.value;
          const storedColors = getStoredColors();
          if (storedColors.length) {
            setCookie('selected_color', JSON.stringify(storedColors.filter((v) => v !== color)));
          }
        }
      }

      FacetFiltersForm.closeAllFilterMenus();
      FacetFiltersForm.closeFilterDrawer();

      const href = event.currentTarget?.href || '';
      const url = href.indexOf('?') === -1 ? '' : href.slice(href.indexOf('?') + 1);
      FacetFiltersForm.renderPage(url);
    } catch (error) {
      console.error('[FacetFiltersForm] Active facet click failed', error);
      FacetFiltersForm.resetUiState();
    }
  }

  static renderHerder(html) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const nextHeader = parsedHTML.querySelector('#collection-header');
    const currentHeader = document.querySelector('#collection-header');

    if (!nextHeader || !currentHeader) return;

    currentHeader.innerHTML = nextHeader.innerHTML;
  }

  static renderPagination(html) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const pagination = document.querySelector('#pagination');
    const newPagination = parsedHTML.querySelector('#pagination');

    if (pagination && newPagination) {
      pagination.innerHTML = newPagination.innerHTML;
    }

    const pageLoadStatus = document.querySelector('.page-load-status');
    const newPageLoadStatus = parsedHTML.querySelector('.page-load-status');
    const productGrid = document.getElementById('sofa-collection');

    if (newPageLoadStatus) {
      if (pageLoadStatus) {
        pageLoadStatus.replaceWith(newPageLoadStatus.cloneNode(true));
      } else if (productGrid) {
        productGrid.insertAdjacentElement('afterend', newPageLoadStatus.cloneNode(true));
      }
    } else if (pageLoadStatus) {
      pageLoadStatus.remove();
    }

    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      publish(PUB_SUB_EVENTS.collectionPaginationChange, {});
    }
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
FacetFiltersForm.pendingSearchParams = FacetFiltersForm.searchParamsPrev;
FacetFiltersForm.abortController = null;
FacetFiltersForm.activeRequestId = 0;
FacetFiltersForm.isRendering = false;
FacetFiltersForm.failedRequestCount = 0;

if (!customElements.get('facet-filters-form')) {
  customElements.define('facet-filters-form', FacetFiltersForm);
}

FacetFiltersForm.setListeners();

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    if (!facetLink) return;

    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form?.onActiveFilterClick(event);
  }
}

if (!customElements.get('facet-remove')) {
  customElements.define('facet-remove', FacetRemove);
}
